import { TGetMeDto } from "@/api/services/main/auth/dtos/get-me.dto";
import { CurrentUser } from "@/infrastructure/adapters/current-user/current-user.types";

/**
 * Map API response to CurrentUser interface
 */
export const mapToCurrentUser = (dto: TGetMeDto): CurrentUser => ({
  id: dto.id,
  fullName: dto.fullName,
  email: dto.email,
  userType: dto.type,
  rsoId: dto.rsoId,
  companyId: dto.companyId,
  match: dto.match,
  company: dto.company,
  isUser: dto.isUser,
});
